module.exports = __webpack_public_path__ + "static/img/defaultpic.08a5227.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/defaultpic.png
// module id = oKTe
// module chunks = 89